<template>
  <div>
    <el-button style="float: right;margin-right: 5px;" icon='el-icon-edit' size='mini' type='danger' @click="handleDelete()">删除</el-button>
    <el-button :loading="handleSaveLoading" style="float: right;margin-right: 5px;" icon='el-icon-edit' size='mini' type="success" @click="handleSave()">保存</el-button>
    <el-button style="float: right;margin-right: 5px;" icon='el-icon-plus' size='mini' type="primary" @click="handleNewRows()">新增</el-button>
    <h3>主要设备清单</h3>
    <el-table-edit :model="dataList" ref="editTable">
      <el-table :data="dataList" size="small" :row-class-name="rowClassName" @row-click="editAll" @selection-change="selectionChangeHandle">
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column label="序号" align="center" width="90px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="majorDivice" label="主要设备" header-align="center" align="center" width="151px">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.majorDivice" placeholder="主要设备"></el-input>
            <span v-else>{{scope.row.majorDivice}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="规格型号" header-align="center" align="center" width="151px">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.model" placeholder="规格型号"></el-input>
            <span v-else>{{scope.row.model}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" header-align="center" align="center" width="151px">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.num" placeholder="数量"></el-input>
            <span v-else>{{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="exFactoryDate" label="出厂日期" header-align="center" align="center" width="250px">
          <template slot-scope="scope">
            <el-date-picker v-if="scope.row.show" v-model="scope.row.exFactoryDate" type="date" format="yyyy-MM-dd"></el-date-picker>
            <!--<el-input v-if="scope.row.show" v-model="scope.row.exFactoryDate" placeholder="出厂日期"></el-input>-->
            <span v-else>{{scope.row.exFactoryDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="placeOfProduction" label="设备厂家" header-align="center" align="center" width="151px">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.placeOfProduction" placeholder="设备厂家"></el-input>
            <span v-else>{{scope.row.placeOfProduction}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="设备参数" header-align="center" align="center" width="151px">
          <template slot-scope="scope">
            <el-button icon="el-icon-upload2" type="text" @click="fileView(scope.row)"></el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="originalValue" label="设备原值" header-align="center" align="center" width="151px">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.originalValue" placeholder="设备原值"></el-input>
            <span v-else>{{scope.row.originalValue}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="accuracy" label="设备精度" header-align="center" align="center" width="151px">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.accuracy" placeholder="设备精度"></el-input>
            <span v-else>{{scope.row.accuracy}}</span>
          </template>
        </el-table-column> -->
      </el-table>
    </el-table-edit>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10,15,20]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>

    <el-dialog
          title="提示"
          :visible.sync="fileDialogVisible"
          width="60%"
          :modal="false"
          >

          <!-- 上传下载 产看 需求文档 -->
            <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="fileDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
  </div>
</template>

<script>
  import { saveSupplierEquipments, listSupplierEquipments, listInvitedForSupplier,deleteSupplierEquipmentsById } from '@/controller/portal'
import Vue from 'vue'
import FileUpDown from "@/views/common/file-up-down"

export default {
  computed: {
    editTable() {
      return this.$refs.editTable
    }
  },
  data () {
    return {
      // 附件类型-供应商门户
      FILE_BIZ_TYPE:14,
      // 附件小类型-主要设备清单
      FILE_SUB_TYPE:1,
      fileDialogVisible:false,
      handleSaveLoading:false,
      show:false,
      dataList: [],
      totalPage: 0,
      pageIndex:1,
      pageSize:10,
      majorDivice:'',
      model: '',
      num: '',
      exFactoryDate: '',
      placeOfProduction:'',
      originalValue:'',
      accuracy:'',
      venderInviteFid: '',
      email: '',
      // applyStatus: ''
      dataForm:{
        id:''
      },
    }
  },
  mounted() {
    // this.getUserInfo()
    this.getList()
  },
  watch: {
    // email() {
    // },
    venderInviteFid() {
      this.getDataList()
    }
  },
  props: {
    superId: Number
  },
  components: {
      FileUpDown //上传附件
  },
  methods: {
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    handleNewRows () {
      this.dataList.push({
        edit: true,
      })
    },
    //多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    rowClassName({
      row,
      rowIndex
    }) {
      row.rowid = rowIndex + 1;
    },
    handleDelete(row) {
      var ids = row ? [row.id] : this.dataListSelections.map(item => {
        return item.id
      })
      var rowids = row ? [row.rowid] : this.dataListSelections.map(item => {
        return item.rowid
      })
      // var majorDiviceIds = row ? [row.majorDiviceId + ';' + row.num] : this.dataListSelections.map(item => {
      //   return item.majorDiviceId + ';' + item.num
      // })
      this.$confirm(`确定对第【${rowids.join(',')}】行进行[${row ? '删除' : '删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        deleteSupplierEquipmentsById(
          {'ids':ids}
          ).then(data => {
            if (data && data.code === '00') {
              this.getDataList()
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            }
        }).catch((e)=>{}).finally(()=>{})

      }).catch((e)=>{}).finally(()=>{})
    },
    editAll() {
      //if(this.applyStatus != null) {
        this.dataList.map((i, index) => {
          i.show = true
          Vue.set(this.dataList, index, i)
        })
      // } else {
      //   this.show = false
      // }
    },
    handleSave() {
      this.$refs.editTable.validate(valid => {
        // valid 为布尔值 代表表格正在编辑的所有字段是否验证通过
        if (valid) {
          const me = this
          //debugger
          // me.dataList.forEach(function (item, index) {
          //   if (me.$refs.editTable.store.getStates(item)["_states"]["editing"]) {
          //       me.editRowslist.push(item)
          //   }
          // })
          //保存方法
          this.saveData(me.dataList)
          me.editTable.cancelRows(this.dataList, false)
          me.$refs.table.clearSelection()
        }
      })
    },
    saveData(list) {
      this.handleSaveLoading = true
      saveSupplierEquipments({
        'equipmentList' : list,
        'inviteId': this.superId
      }).then(data => {
        if (data && data.code === '00') {
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.getDataList()
          this.handleSaveLoading = false
        } else {
          this.handleSaveLoading = false
          this.$message.error(data.msg)
        }
      }).catch((e) => {
        this.handleSaveLoading = false
      })
    },
    getDataList() {
      listSupplierEquipments({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'inviteId' : this.superId
      }).then(data => {
        if (data && data.code === '00') {
          if (data.body.records.length > 0){
            this.dataList = data.body.records
            this.totalPage = data.body.total
          }
        } else {
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    getList() {
      listInvitedForSupplier().then(data => {
        this.venderInviteFid = data.body.records[0].id
      })
    },
    // 获取当前管理员信息
    getUserInfo () {
      // this.$http({
      //   url: this.$http.adornUrl('/sys/user/info'),
      //   method: 'get',
      //   params: this.$http.adornParams()
      // }).then((result) => {
      //   const data = result.data
      //   if (data && data.code === 0) {
      //     this.email = data.user.username
      //   }
      // })
    },

    // 文件列表
      fileView(row){
        debugger
        this.dataForm.id = row.id;
        this.fileDialogVisible = true
        this.$nextTick(()=>{
            this.$refs.FileUpDown.init(this.dataForm.id, this.FILE_BIZ_TYPE, null)
        })
      },
  }
}
</script>